// https://www.hl7.org/fhir/codesystem-nhin-purposeofuse.html
export enum PurposeOfUse {
  TREATMENT = "TREATMENT",
  PAYMENT = "PAYMENT",
  OPERATIONS = "OPERATIONS",
  SYSADMIN = "SYSADMIN",
  FRAUD = "FRAUD",
  PSYCHOTHERAPY = "PSYCHOTHERAPY",
  TRAINING = "TRAINING",
  LEGAL = "LEGAL",
  MARKETING = "MARKETING",
  DIRECTORY = "DIRECTORY",
  FAMILY = "FAMILY",
  PRESENT = "PRESENT",
  EMERGENCY = "EMERGENCY",
  DISASTER = "DISASTER",
  PUBLICHEALTH = "PUBLICHEALTH",
  ABUSE = "ABUSE",
  OVERSIGHT = "OVERSIGHT",
  JUDICIAL = "JUDICIAL",
  LAW = "LAW",
  DECEASED = "DECEASED",
  DONATION = "DONATION",
  RESEARCH = "RESEARCH",
  THREAT = "THREAT",
  GOVERNMENT = "GOVERNMENT",
  WORKERSCOMP = "WORKERSCOMP",
  COVERAGE = "COVERAGE",
  REQUEST = "REQUEST",
}
